/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { SegmentedControlView } from '@airasia-phoenix/react-native/components/SegmentedControlView';
import { TripType, TripTypeSelectorProps } from './types';

const TripTypeSelectorView = (props: TripTypeSelectorProps) => {
  const { tripType, onChange, autoSearch } = props;
  const { t } = useTranslation('flights');

  const initialValuesRef = useRef<TripType>(tripType);

  useEffect(() => {
    initialValuesRef.current = tripType;
  }, [tripType]);

  const tripOptions = [
    {
      key: TripType.ONE_WAY,
      text: t('flightsSearchPage.main.oneWayLabel'),
    },
    {
      key: TripType.ROUND_TRIP,
      text: t('flightsSearchPage.main.roundTripLabel'),
    },
  ];

  return (
    <SegmentedControlView
      options={tripOptions}
      defaultSelectedItem={tripOptions.findIndex(
        (option) => option.key === tripType,
      )}
      onSelect={(selectedValues) => {
        const selectedKey = selectedValues.key;

        if (Object.values(TripType).includes(selectedKey as TripType)) {
          const selectedTripType = selectedValues.key as TripType;
          onChange(selectedTripType);

          const didTripTypeChange =
            initialValuesRef.current !== selectedTripType;

          if (didTripTypeChange) {
            autoSearch?.(selectedTripType);
          }
        } else {
          console.error(`Invalid trip type key received: ${selectedKey}`);
        }
      }}
      visibleSegments={2}
    />
  );
};

export default TripTypeSelectorView;
